module.exports = __webpack_public_path__ + "img/stock4.79792154.png";